// SEE https://github.com/mobxjs/mobx/discussions/3195
export function* result(promise) {
    return yield promise;
}
